import {
    sendPostRequest,
    sendDeleteRequest,
    sendGetRequest,
    sendPutRequest
} from "@/helper/requests";
import entitled from "@/urls/roles/entitled";
import {executeRequest} from "@/store/utils";

const state = {
    guard: {
        login: [],
        loading: false,
        error: null
    }
}

const getters = {
    getGuardLogin: state => state.guard.login
}

const actions = {
    loadGuardLogin: ({commit}, {url, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) url =entitled.ENTITLED.GUARD.LOGIN()
        sendGetRequest(
            url, (data, url) => {
                commit("SET_GUARD_LOGIN", data);
                finalizer(data, url);
            }, (data, url) => {
                commit("SAVE_GUARD_ERROR", data);
                catcher(data, url);
            }
        )
    },
    chatApprove: ({commit}, {gets, finalizer,catcher}) => {
        let url = entitled.ENTITLED.GUARD.CHAT_APPROVE(gets)
        sendGetRequest(
            url, (data, url) => {
                commit("SET_GUARD_LOGIN", data);
                finalizer(data, url);
            }, (data, url) => {
                commit("SAVE_GUARD_ERROR", data);
                catcher(data, url);
            }
        )
    }
}

const mutations = {
    SET_GUARD_LOGIN: (state, value) => {
        state.guard.login = value
    },
    SET_GUARD_LOADING: (state) => {
        state.guard.loading = true
    },
    SET_GUARD_LOADING_END: (state) => {
        state.guard.loading = false
    },
    SAVE_GUARD_ERROR: (state, error) => {
        state.guard.error = error
    }
}

export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
